import {
  Avatar,
  Badge,
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Icon,
  Input,
  InputNumber,
  List,
  message,
  Modal,
  Popconfirm,
  Row,
  Select,
  Table,
  Tag,
  TimePicker
} from 'antd';
import {inject, observer} from 'mobx-react';
import * as React from 'react';
import {Fragment} from 'react';
import {Helmet} from 'react-helmet';
import Highlighter from 'react-highlight-words';
import {RouteComponentProps} from 'react-router';
import {Link} from 'react-router-dom';
import Card, {CardBody, CardHeader} from '../../components/Card';
import Layout, {Main} from '../../components/Layout';
import airbnBadge from '../../images/airbnb-badge.svg';
import bookingBadge from '../../images/booking-badge.svg';
import cohostBadge from '../../images/cohost-badge.png';
import {Auth} from '../../models/authModel';
import {FetchAirbnbListingsModelType} from '../../models/IntegrationModel';
import {LanguageModel} from '../../models/LanguageModel';
import {LanguagesListModelType} from '../../models/LanguagesListModel';
import {ListingsListModelType} from '../../models/ListingsListModel';
import {OtaAccountsListModelType} from '../../models/OtaAccountsListModel';
import {RolesListModelType} from '../../models/RolesListModel';
import {StaahListingDetailModelType} from '../../models/StaahListingDetailModel';
import {TeamDetailModelType} from '../../models/TeamDetailModel';
import {TeamSettingsDetailModelType} from '../../models/TeamSettingDetailModel';
import {V3ListingListModelType} from '../../models/V3ListingListModel';
import './index.css';

const Option = Select.Option;

const Source = [
  'airbnb.com',
  'booking.com',
  'vrbo.com',
  'agoda.com',
  'dayladau.com',
  'expedia.com',
  'traveloka.com',
  'cohost.club',
  'facebook.com',
  'instagram.com',
  'luxstay.com',
  'waka.life',
  'tujia.com',
  'tripadvisor.com',
  'misterbandb.com',
  'tiktok.com',
  'whatsapp.com',
  'viber.com',
  'hotelrunner.com',
  'email',
  'phone',
  'zalo.me'
];

// tslint:disable
interface WithInjectedProps extends RouteComponentProps<{teamId: string}> {
  teamDetail: TeamDetailModelType;
  auth: Auth;
  rolesList: RolesListModelType;
  listingsList: ListingsListModelType;
  otaAccountsList: OtaAccountsListModelType;
  languagesList: LanguagesListModelType;
  fetchAirbnbListingsAirbnb: FetchAirbnbListingsModelType;
  teamSettingDetail: TeamSettingsDetailModelType;
  staahListingsDetail: StaahListingDetailModelType;
  v3ListingList: V3ListingListModelType;
}

interface TeamDetailState {
  searchText: string;
  staahListingId: string;
  staahRateId: string;
}

@inject(
  'teamDetail',
  'rolesList',
  'listingsList',
  'otaAccountsList',
  'languagesList',
  'fetchAirbnbListingsAirbnb',
  'teamSettingDetail',
  'staahListingsDetail',
  'v3ListingList'
)
@observer
class TeamDetail extends React.Component<
  RouteComponentProps,
  TeamDetailState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      searchText: '',
      staahListingId: '',
      staahRateId: ''
    };
  }

  getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }: any) => (
      <div style={{padding: 8}}>
        <Input
          // ref={node => {
          //   this.searchInput = node;
          // }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{width: 188, marginBottom: 8, display: 'block'}}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{width: 90, marginRight: 8}}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{width: 90}}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered: any) => (
      <Icon type="search" style={{color: filtered ? '#1890ff' : undefined}} />
    ),
    onFilter: (value: any, record: any) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible: any) => {
      if (visible) {
        // setTimeout(() => this.searchInput.select());
      }
    },
    render: (text: any) => {
      return (
        <Highlighter
          highlightStyle={{backgroundColor: '#ffc069', padding: 0}}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      );
    }
  });

  handleSearch = (selectedKeys: any, confirm: any) => {
    confirm();
    this.setState({searchText: selectedKeys[0]});
  };

  handleReset = (clearFilters: any) => {
    clearFilters();
    this.setState({searchText: ''});
  };

  componentWillUnmount() {
    this._withInjectedProps.listingsList.clearEntries();
    this._withInjectedProps.otaAccountsList.clearEntries();
  }
  componentDidMount() {
    this._withInjectedProps.teamDetail.getTeamDetail(this._teamId);
    this._withInjectedProps.teamSettingDetail.getTeamSettings(this._teamId);
    this._withInjectedProps.otaAccountsList.loadEntries(this._teamId, 50, 0);
    this._withInjectedProps.rolesList.loadEntries('team');
    this._withInjectedProps.languagesList.loadEntries();
    this._withInjectedProps.staahListingsDetail.getStaahListing(this._teamId);
    this._withInjectedProps.teamSettingDetail.getStaahSetting(this._teamId);
    this._loadListing();
    this._withInjectedProps.v3ListingList.loadEntries({
      teamId: this._teamId,
      offset: 0,
      limit: 100
    });
  }

  private get _teamId() {
    return Number(this._withInjectedProps.match.params.teamId);
  }
  private get _withInjectedProps() {
    return this.props as WithInjectedProps;
  }

  render() {
    const {isLoading, team} = this._withInjectedProps.teamDetail;
    return (
      <React.Fragment>
        <Helmet>
          <title>Team Detail</title>
        </Helmet>
        <Layout>
          <Main>
            <Card>
              <CardHeader>Team Detail</CardHeader>
              {isLoading ? this._loading() : this._detailTeam(team)}
            </Card>
          </Main>
        </Layout>
      </React.Fragment>
    );
  }

  private _detailTeam(team: any) {
    return team ? (
      <React.Fragment>
        <CardBody>
          {this._renderBasicInfo(team)}
          <Divider />
          {this._renderOtaAccounts()}
          <Divider />
          {this._renderFacebookAccount()}
          <Divider />
          {this._renderZaloAccount()}
          <Divider />
          {this._renderTeamLanguages(team)}
          <Divider />
          {this._renderTeamMembers(team)}
          <Divider />
          {this._renderListings(team)}
          <Divider />
          {this._renderEditTeamName(team)}
          <Divider />
          {this._renderStaahMappingSection()}
          {this._renderAddNewOtaAccount()}
          {this._renderModalEditOtaAccount()}
          {this._renderModalAddNewListing()}
          {this._renderModalEditTeamLanguages(team)}
        </CardBody>
      </React.Fragment>
    ) : null;
  }

  private _renderTeamLanguages(team: any) {
    return (
      <React.Fragment>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <h3
            style={{
              fontSize: 20,
              fontWeight: 'bold',
              marginTop: 20,
              marginBottom: 15
            }}
          >
            <span>Team languages</span> <Badge count={team.languages.size} />
          </h3>
          <Icon
            style={{cursor: 'pointer'}}
            type="edit"
            onClick={this.onToggleEditingTeamLanguages}
          />
        </div>

        <Row>
          <Table
            bordered={true}
            columns={this._dataHeaderTableTeamLanguage()}
            dataSource={this._cvtDataTeamLanguages(team.languages)}
          />
        </Row>
      </React.Fragment>
    );
  }

  private onToggleEditingTeamLanguages = () => {
    this._withInjectedProps.teamDetail.onToggleEditingTeamLanguages();
  };

  private _renderModalEditTeamLanguages(team: any) {
    const {entries} = this._withInjectedProps.languagesList;
    const {
      isEditingTeamLanguages,
      isUpdateTeamLanguage
    } = this._withInjectedProps.teamDetail;
    const languages = Array.from(entries.values());
    const arrayLanguages = Array.from(team.languages.values()) || [];
    const defaultLanguages = arrayLanguages.map(
      (language: LanguageModel, index) => {
        return String(language.id);
      }
    );

    return (
      <Modal
        style={{top: 20}}
        width={1000}
        title="Edit Team Languages"
        onCancel={this.onToggleEditingTeamLanguages}
        onOk={this.onUpdateTeamLanguages}
        visible={isEditingTeamLanguages}
        okText="Update"
        okButtonDisabled={isUpdateTeamLanguage}
      >
        <Select
          mode="multiple"
          style={{width: '100%'}}
          placeholder="Languages"
          onChange={this.onChangeTeamLanguages}
          defaultValue={defaultLanguages}
        >
          {languages.map((language: any, idx: number) => {
            return (
              <Option key={String(idx)} value={String(language.id)}>
                {`${language.name} - ${language.code}`}
              </Option>
            );
          })}
        </Select>
      </Modal>
    );
  }

  private _renderModalEditStaahAccount() {
    const {
      isEditingStaahAccount,
      staahTeamSetting
    } = this._withInjectedProps.teamSettingDetail;

    const formItemLayout = {
      labelCol: {
        xs: {span: 24},
        sm: {span: 8}
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16}
      }
    };

    return (
      <Modal
        style={{top: 20}}
        width={1000}
        title="Edit Staah Account"
        onCancel={
          this._withInjectedProps.teamSettingDetail.toggleEditingStaahAccount
        }
        onOk={this.onUpdateStaahAccount}
        visible={isEditingStaahAccount}
        okText="Update"
        okButtonDisabled={isEditingStaahAccount}
      >
        <Form>
          <Form.Item {...formItemLayout} label="Hotel Id">
            <Input
              defaultValue={
                staahTeamSetting ? staahTeamSetting.params.hotelId : ''
              }
              placeholder="Hotel Id"
              onBlur={this.onChangeStaahHotelId}
              onChange={this.onChangeStaahHotelId}
            />
          </Form.Item>
          <Form.Item {...formItemLayout} label="Username">
            <Input
              defaultValue={
                staahTeamSetting ? staahTeamSetting.params.username : ''
              }
              placeholder="Username"
              onBlur={this.onChangeStaahUsername}
              onChange={this.onChangeStaahUsername}
            />
          </Form.Item>
          <Form.Item {...formItemLayout} label="Password">
            <Input
              defaultValue={
                staahTeamSetting ? staahTeamSetting.params.password : ''
              }
              placeholder="Password"
              onBlur={this.onChangeStaahPassword}
              onChange={this.onChangeStaahPassword}
            />
          </Form.Item>
        </Form>
      </Modal>
    );
  }

  private _renderStaahMappingSection = () => {
    const {
      staahTeamSetting,
      isStaahLoading
    } = this._withInjectedProps.teamSettingDetail;

    return (
      <React.Fragment>
        {this._renderModalEditStaahAccount()}
        {this._renderModalListingMapping()}
        <h3 style={{fontSize: 20, fontWeight: 'bold', marginTop: 20}}>
          Staah Listing Mapping
        </h3>
        <Row
          className="basic-info"
          style={{border: '1px solid #f0f0f0', borderRadius: 5, padding: 10}}
        >
          {isStaahLoading ? (
            this._loading()
          ) : staahTeamSetting ? (
            <Col span={17}>
              <Row className="item-basic">
                <Col span={8} className="item-header">
                  Hotel ID:
                </Col>
                <Col span={16} className="item-content">
                  {staahTeamSetting ? staahTeamSetting.params.hotelId : ''}
                </Col>
              </Row>
              <Row className="item-basic">
                <Col span={8} className="item-header">
                  Username
                </Col>
                <Col span={16} className="item-content">
                  {staahTeamSetting ? staahTeamSetting.params.username : ''}
                </Col>
              </Row>
              <Row className="item-basic">
                <Col span={8} className="item-header">
                  Password
                </Col>
                <Col span={16} className="item-content">
                  {staahTeamSetting ? staahTeamSetting.params.password : ''}
                </Col>
              </Row>
            </Col>
          ) : (
            <Col span={17}>
              <Tag color="magenta">Not set yet</Tag>
            </Col>
          )}
          <Col span={4}>
            <Button
              type="primary"
              style={{float: 'right'}}
              onClick={
                this._withInjectedProps.teamSettingDetail
                  .toggleEditingStaahAccount
              }
            >
              Update Staah Account
            </Button>
          </Col>
        </Row>
        <Row />

        <Row style={{marginTop: 10}}>
          <Table
            bordered={true}
            columns={this._dataHeaderTableStaahMapping()}
            dataSource={this._dataSourceStaahMapping()}
          />
        </Row>
      </React.Fragment>
    );
  };
  private onUpdateTeamLanguages = () => {
    this._withInjectedProps.teamDetail.updateTeamLanguages(
      this._teamId,
      this.notifyMessage
    );
  };

  private onUpdateStaahAccount = () => {
    this._withInjectedProps.teamSettingDetail.updateStaahAccount(
      this._teamId,
      this.notifyMessage
    );
  };

  private onChangeTeamLanguages = (languageIds: Array<string>) => {
    const newLanguageIds = languageIds.map((languageId, idx) => {
      return Number(languageId);
    });
    this._withInjectedProps.teamDetail.onChangeLanguageIds(newLanguageIds);
  };

  private _cvtDataTeamLanguages(entries: any) {
    const languages = Array.from(entries.values());
    return languages.map((language: any, idex: number) => {
      return this._itemLanguageTable(language);
    });
  }

  private _dataHeaderTableTeamLanguage() {
    return [
      {
        title: 'Id',
        dataIndex: 'id',
        key: 'id'
      },
      {
        title: 'Code',
        dataIndex: 'code',
        key: 'code'
      },
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name'
      }
    ];
  }

  private _dataHeaderTableStaahMapping() {
    return [
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id'
      },
      {
        title: 'Listing Name',
        dataIndex: 'listingName',
        key: 'name'
      },
      {
        title: 'Staah Listing Id',
        dataIndex: 'staahListingId',
        key: 'staahListingId'
      },
      {
        title: 'Staah Rate Id',
        dataIndex: 'staahRateId',
        key: 'staahRateId'
      },
      {
        title: 'Action',
        dataIndex: 'action',
        key: 'action'
      }
    ];
  }

  private _dataSourceStaahMapping = () => {
    const {entries} = this._withInjectedProps.v3ListingList;
    const v3Listings = Array.from(entries.values());

    return v3Listings.map(listing => {
      return {
        key: listing.id,
        id: listing.id,
        listingName: listing.name,
        staahListingId: listing.staahListingId,
        staahRateId: listing.staahRateId,
        action: (
          <Button
            type="primary"
            onClick={() => {
              this._withInjectedProps.v3ListingList.setCurrentEditingV3ListingName(
                listing.name
              );
              this._withInjectedProps.v3ListingList.setCurrentEditingV3ListingId(
                listing.id
              );
              this._withInjectedProps.v3ListingList.toggleIsEditingV3Listing();
            }}
          >
            Update
          </Button>
        )
      };
    });
  };

  private _renderTeamMembers(team: any) {
    const {isLoadingAddNewMember} = this._withInjectedProps.teamDetail;
    return (
      <React.Fragment>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
          <h3
            style={{
              fontSize: 20,
              fontWeight: 'bold',
              marginTop: 20,
              marginBottom: 15,
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center'
            }}
          >
            <span>Members</span>
            &nbsp;
            <Badge count={team.members.size} />
          </h3>
        </div>
        <Row>
          <Row>
            <Row
              className="wrap-add-new"
              gutter={24}
              type="flex"
              align="middle"
            >
              <Col span={2}>
                <span className="title-box-add-new">UserId</span>
              </Col>
              <Col span={4}>
                <Input
                  onChange={this.onChangeUserId}
                  onBlur={this.onBlurUserId}
                />
              </Col>
              <Col span={2}>
                <span className="title-box-add-new">Role</span>
              </Col>
              <Col span={4}>
                <Select
                  showSearch={true}
                  style={{width: 150}}
                  placeholder="Select role"
                  onChange={this.onChangeRoleId}
                >
                  {this._renderSelectRole()}
                </Select>
              </Col>
              <Col span={4}>
                <Button
                  type="primary"
                  onClick={() => this.onClickAddNew(this._teamId)}
                  loading={isLoadingAddNewMember}
                >
                  Add New Member
                </Button>
              </Col>
            </Row>
          </Row>
          {this._renderChooseListings()}
          <Row>
            <Table
              bordered={true}
              columns={this._dataHeaderTableMembers()}
              dataSource={this._cvtDataMembers(team.members)}
            />
          </Row>
        </Row>
      </React.Fragment>
    );
  }

  private _renderListings(team: any) {
    const {entries, isLoading} = this._withInjectedProps.listingsList;
    const {
      isLoadingAssignMemberManageListings,
      isAddingAirbnbListingId
    } = this._withInjectedProps.teamDetail;
    const teamMembers = Array.from(team.members.values());
    return (
      <React.Fragment>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginTop: 20,
            marginBottom: 15
          }}
        >
          <h3
            style={{
              fontSize: 20,
              fontWeight: 'bold',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center'
            }}
          >
            <span>Listings</span> <Badge count={entries.size} />
          </h3>
          <Button
            size="small"
            type="primary"
            onClick={this.onToggleAddNewListing}
          >
            Manualy Add NewListing
          </Button>
        </div>
        <Row
          style={{
            border: '1px solid #bfbfbf',
            borderRadius: 10,
            padding: 10
          }}
        >
          <h3 style={{fontWeight: 'bold', marginBottom: 15}}>
            Assign Member Manage Listings
          </h3>
          <Row type="flex" align="middle">
            <Col span={2}>
              <span>Members</span>
            </Col>
            <Col span={15}>
              <Select
                mode="tags"
                style={{width: '100%'}}
                placeholder="Members"
                allowClear={true}
                onChange={this.onChangeAssignMemberOfListing}
              >
                {teamMembers.map((member: any, idx: number) => {
                  return (
                    <Option key={String(idx)} value={String(member.id)}>
                      {`${member.id} - ${member.firstName} ${member.lastName}`}
                    </Option>
                  );
                })}
              </Select>
            </Col>
            <Col span={3}>
              <a
                href="#"
                onClick={this.onChooseListings}
                style={{paddingLeft: 10}}
              >
                Choose Listings
              </a>
            </Col>
            <Col span={3}>
              <Button
                size="small"
                type="primary"
                onClick={this.onSubmitAssignMemberListings}
                loading={isLoadingAssignMemberManageListings}
              >
                Assign
              </Button>
            </Col>
          </Row>
        </Row>

        <Row
          style={{
            border: '1px solid #bfbfbf',
            borderRadius: 10,
            padding: 10,
            marginTop: 10,
            marginBottom: 15
          }}
        >
          <Row style={{marginBottom: 15}}>
            <h3 style={{fontWeight: 'bold'}}>Add new listing Airbnb</h3>
          </Row>
          <Row>
            <Col span={10}>
              <InputNumber
                style={{width: 400}}
                onChange={this.onChangeNewAirbnbListingId}
                placeholder="Airbnb Listing Id Ex: 20823298"
              />
            </Col>
            <Col span={4}>
              <Button
                loading={isAddingAirbnbListingId}
                onClick={this.onAddNewAirbnbListingId}
                style={{marginLeft: 10}}
                type="primary"
              >
                +Add
              </Button>
            </Col>
          </Row>
        </Row>

        <Row>
          <Table
            bordered={true}
            columns={this._dataHeaderTableListings()}
            dataSource={this._cvtDataListings(entries)}
            loading={isLoading}
          />
        </Row>
      </React.Fragment>
    );
  }

  private onChangeNewAirbnbListingId = (value: number) => {
    this._withInjectedProps.teamDetail.onChangeNewAirbnbListingUrl(
      String(value)
    );
  };
  private onAddNewAirbnbListingId = () => {
    const {entries} = this._withInjectedProps.otaAccountsList;
    const otaAccounts = Array.from(entries.values());
    const airbnbAccounts = otaAccounts.filter((item, idx) => {
      return item.source == 'airbnb.com';
    });
    if (!airbnbAccounts || airbnbAccounts.length == 0) {
      this.notifyMessage('error', 'Not Found Ota Account');
      return;
    }

    this._withInjectedProps.teamDetail.fetAirbnbResources(
      airbnbAccounts[0].id,
      this.notifyMessage
    );
  };
  private onSubmitAssignMemberListings = () => {
    const {listingIds, userIds} = this._withInjectedProps.teamDetail;

    if (listingIds.length === 0 || userIds.length === 0) {
      this.notifyMessage('error', 'Please select listings and users');
      return;
    }
    this._withInjectedProps.teamDetail.bulkAssignMemberToListings(
      this._teamId,
      userIds,
      listingIds,
      this.notifyStatus
    );
  };

  private onChangeAssignMemberOfListing = (memberIds: Array<string>) => {
    const userIds = memberIds.map((userId: string, _: number) => {
      return Number(userId);
    });
    this._withInjectedProps.teamDetail.onChangeUserIds(userIds);
  };

  private onToggleAddNewListing = () => {
    this._withInjectedProps.teamDetail.onToggleAddNewListing();
  };

  private onSubmitAddNewListing = () => {
    const {newListing} = this._withInjectedProps.listingsList;
    const {
      name,
      teamId,
      address,
      timezoneName,
      countryCode,
      bedrooms,
      internalName,
      propertyType,
      summary,
      checkInTime,
      checkOutTime,
      source,
      otaListingId,
      image,
      primaryHostName
    } = newListing;

    if (
      !name ||
      !teamId ||
      !timezoneName ||
      !source ||
      !otaListingId ||
      !address ||
      !image ||
      !primaryHostName
    ) {
      this.notifyMessage(
        'error',
        'Please fullfill data: Name, Address, Timezone, Source, Ota Listing Id, Image, Primary Host Name'
      );
      return;
    }
    const body = {
      name,
      teamId,
      address,
      timezoneName,
      countryCode,
      bedrooms,
      internalName,
      propertyType,
      summary,
      checkInTime,
      checkOutTime,
      source,
      otaListingId,
      images: [
        {
          url: image,
          small: image,
          thumbnail: image,
          large: image
        }
      ]
    };
    this._withInjectedProps.listingsList.createListing(body);
    this._withInjectedProps.teamDetail.onToggleAddNewListing();
  };

  private onUpdateStaahListingMapping = () => {
    const {staahListingId, staahRateId} = this.state;
    if (staahListingId === '' || staahRateId === '') {
      this.notifyMessage('error', 'Please full fill form');
    }
    this._withInjectedProps.v3ListingList.updateStaahListingMapping(
      staahListingId,
      staahRateId,
      this.notifyMessage
    );
  };

  private onChangeNameListingModal = (event: any) => {
    this._withInjectedProps.listingsList.onChangeNameListing(
      event.target.value
    );
    this._withInjectedProps.listingsList.onChangeTeamIdListing(this._teamId);
  };

  private onChangeInternalNameListingModal = (event: any) => {
    this._withInjectedProps.listingsList.onChangeInternalNameListing(
      event.target.value
    );
  };

  private onChangeAddressListingModal = (event: any) => {
    this._withInjectedProps.listingsList.onChangeAddressListing(
      event.target.value
    );
  };

  private onChangeTimezoneNameListingModal = (event: any) => {
    this._withInjectedProps.listingsList.onChangeTimezoneNameListing(
      event.target.value
    );
  };

  private onChangeCheckInTimeListingModal = (
    time: any,
    timeString: string
  ) => {
    this._withInjectedProps.listingsList.onChangeCheckInTimeListing(
      timeString
    );
  };

  private onChangeCheckOutTimeListingModal = (
    time: any,
    timeString: string
  ) => {
    this._withInjectedProps.listingsList.onChangeCheckOutTimeListing(
      timeString
    );
  };

  private onChangeSourceListingModal = (value: string) => {
    this._withInjectedProps.listingsList.onChangeSourceListing(value);
  };

  private onChangeOtaListingIdModal = (event: any) => {
    this._withInjectedProps.listingsList.onChangeOtaListingId(
      event.target.value
    );
  };
  private onChangeCountryCodeListingModal = (event: any) => {
    this._withInjectedProps.listingsList.onChangeCountryCodeListing(
      event.target.value
    );
  };

  private onChangePrimaryHostNameListingModal = (event: any) => {
    this._withInjectedProps.listingsList.onChangePrimaryHostNameListing(
      event.target.value
    );
  };

  private onChangeLinkImageListingModal = (event: any) => {
    this._withInjectedProps.listingsList.onChangeImageListing(
      event.target.value
    );
  };

  private _renderModalAddNewListing() {
    const {isAddNewListing} = this._withInjectedProps.teamDetail;
    const {isLoadingAddNewListing} = this._withInjectedProps.listingsList;
    const format = 'HH:mm';
    const formItemLayout = {
      labelCol: {
        xs: {span: 24},
        sm: {span: 8}
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16}
      }
    };
    return (
      <Modal
        style={{top: 20}}
        width={1000}
        title="Add new listing to team"
        onCancel={this.onToggleAddNewListing}
        onOk={this.onSubmitAddNewListing}
        visible={isAddNewListing}
        okText="Submit"
        okButtonDisabled={isLoadingAddNewListing}
      >
        <Form>
          <Form.Item {...formItemLayout} label="Name" required={true}>
            <Input
              placeholder="Name"
              onChange={this.onChangeNameListingModal}
            />
          </Form.Item>
          <Form.Item {...formItemLayout} label="Internal Name">
            <Input
              placeholder="Internal Name"
              onChange={this.onChangeInternalNameListingModal}
            />
          </Form.Item>
          <Form.Item {...formItemLayout} label="Address" required={true}>
            <Input
              placeholder="Address"
              onChange={this.onChangeAddressListingModal}
            />
          </Form.Item>
          <Form.Item {...formItemLayout} label="Link Image" required={true}>
            <Input
              placeholder="Link Image"
              onChange={this.onChangeLinkImageListingModal}
              onFocus={this.onChangeLinkImageListingModal}
            />
          </Form.Item>
          <Form.Item {...formItemLayout} label="Timezone Name" required={true}>
            <Input
              placeholder="Timezone Name"
              onChange={this.onChangeTimezoneNameListingModal}
              onFocus={this.onChangeTimezoneNameListingModal}
              defaultValue="Asia/Saigon"
            />
          </Form.Item>
          <Form.Item {...formItemLayout} label="Check In Time">
            <TimePicker
              format={format}
              onChange={this.onChangeCheckInTimeListingModal}
            />
          </Form.Item>
          <Form.Item {...formItemLayout} label="Check Out Time">
            <TimePicker
              format={format}
              onChange={this.onChangeCheckOutTimeListingModal}
            />
          </Form.Item>
          <Form.Item {...formItemLayout} label="Source" required={true}>
            <Select
              style={{width: 150}}
              showSearch={true}
              placeholder="Select source"
              onChange={this.onChangeSourceListingModal}
            >
              {Source.map((source: string, idx: number) => {
                return (
                  <Option key={source} value={source}>
                    {source}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            label="Ota Listing Id"
            required={true}
          >
            <Input
              placeholder="Ota Listing Id. Ex: hr_HR:213522"
              onChange={this.onChangeOtaListingIdModal}
              onFocus={this.onChangeOtaListingIdModal}
            />
          </Form.Item>
          <Form.Item {...formItemLayout} label="Country Code" required={true}>
            <Input
              placeholder="Country Code"
              onChange={this.onChangeCountryCodeListingModal}
              onFocus={this.onChangeCountryCodeListingModal}
              defaultValue="vn"
            />
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            label="Primary Host Name"
            required={true}
          >
            <Input
              placeholder="Primary Host Name"
              onChange={this.onChangePrimaryHostNameListingModal}
              onFocus={this.onChangePrimaryHostNameListingModal}
            />
          </Form.Item>
        </Form>
      </Modal>
    );
  }

  private _renderModalListingMapping() {
    const {
      staahListing,
      isLoading
    } = this._withInjectedProps.staahListingsDetail;

    const {
      currentStaahListing,
      currentEditingV3ListingName,
      isEditingV3Listing
    } = this._withInjectedProps.v3ListingList;

    const formItemLayout = {
      labelCol: {
        xs: {span: 24},
        sm: {span: 8}
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16}
      }
    };
    if (isLoading) {
      return this._loading();
    }

    if (!staahListing || !staahListing.rooms) {
      return null;
    }

    let mapRoomToRates = {};
    staahListing.rooms.forEach(room => {
      mapRoomToRates[room.roomId] = room.rates;
    });

    const options = staahListing.rooms.map(room => {
      return {
        id: room.roomId,
        name: room.roomName
      };
    });

    const rateOptions = currentStaahListing ? currentStaahListing.rates : [];

    return (
      <Modal
        style={{top: 20}}
        width={1000}
        title="Staah Listing Mapping"
        onCancel={
          this._withInjectedProps.v3ListingList.toggleIsEditingV3Listing
        }
        onOk={this.onUpdateStaahListingMapping}
        visible={isEditingV3Listing}
        okText="Update"
        okButtonDisabled={isEditingV3Listing}
      >
        <p style={{textAlign: 'center', paddingBottom: 20}}>
          You are mapping listing{' '}
          <span style={{fontSize: 14, fontWeight: 'bold'}}>
            "{currentEditingV3ListingName}"
          </span>{' '}
          to
        </p>

        <Form>
          <Form.Item {...formItemLayout} label="Staah Listing" required={true}>
            <Select
              value={this.state.staahListingId}
              placeholder="Select Staah Listing"
              onChange={value => {
                const currentListing = staahListing.rooms.filter(
                  staahListing => staahListing.roomId === value
                );
                if (currentListing && currentListing.length > 0) {
                  this._withInjectedProps.v3ListingList.setCurrentStaahListing(
                    currentListing[0]
                  );
                }

                this.setState({
                  staahListingId: value as string,
                  staahRateId: ''
                });
              }}
            >
              {options.map(item => {
                return (
                  <Option key={item.id} value={item.id}>
                    {`${item.name} - ${item.id}`}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item
            {...formItemLayout}
            label="Staah Staah Rate"
            required={true}
          >
            <Select
              value={this.state.staahRateId}
              placeholder="Select Staah Rate Listing"
              onChange={value => {
                this.setState({staahRateId: value as string});
              }}
            >
              {(rateOptions as any).map((rateOption: any) => {
                return (
                  <Option key={rateOption.rateId} value={rateOption.rateId}>
                    {`${rateOption.rateName} - ${rateOption.rateId}`}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    );
  }

  private onBlurUserId = () => {
    // const {newUserId} = this._withInjectedProps.teamDetail;
    // this._withInjectedProps.listingsList.updateStateListingsWithJoinState(
    //   newUserId
    // );
  };

  private onChangeUserId = (event: React.ChangeEvent<HTMLInputElement>) => {
    this._withInjectedProps.teamDetail.onChangeNewUserId(
      Number(event.target.value)
    );
  };

  private onChangeRoleId = (value: number) => {
    this._withInjectedProps.teamDetail.onChangeNewRoleId(value);
  };

  private onClickAddNew(teamId: number) {
    const {newUserId, newRoleID, team} = this._withInjectedProps.teamDetail;

    if (!newUserId || !newRoleID || !team) {
      message.error('Please full fill form data: User ID, Role');
      return;
    }

    // Check user allready in team
    let teamMembers = Array.from(team.members.values());
    if (!this.isMemberOfTeam(newUserId, teamMembers)) {
      console.log(`Will add user ${newUserId} teamId ${teamId}`);
      this._withInjectedProps.teamDetail.assignUserToTeam(teamId);
    } else {
      message.error('User already joined team.');
    }
  }

  private notifyStatus(err: boolean, msg: string) {
    if (err) {
      message.error(msg);
    } else {
      message.success(msg);
    }
  }

  private onChooseListings = () => {
    this._withInjectedProps.teamDetail.toggleChooseListings();
    // this._getListings();
  };

  private isMemberOfTeam(userId: number, members: any) {
    if (!members) {
      return false;
    }

    const memberIds = members.map((member: any, idx: number) => {
      return member.id;
    });

    return memberIds.indexOf(userId) === -1 ? false : true;
  }

  private _loading() {
    return (
      <div style={{margin: 'auto', minHeight: 300}}>
        <Button shape="circle" type="primary" loading={true} />
      </div>
    );
  }

  private cancelModel = () => {
    this._withInjectedProps.teamDetail.toggleChooseListings();
  };

  private _renderChooseListings() {
    const {isOpenChooseListings} = this._withInjectedProps.teamDetail;
    const {isLoading} = this._withInjectedProps.listingsList;

    return (
      <Modal
        style={{top: 20}}
        title="Choose listings to apply"
        visible={isOpenChooseListings}
        onCancel={this.cancelModel}
        onOk={this.cancelModel}
      >
        <div style={{maxHeight: 500, overflowY: 'scroll'}}>
          {isLoading ? this._loading() : this._renderListListings()}
        </div>
      </Modal>
    );
  }

  private _renderListListings() {
    const arrayListings = this._getListings();
    const listingIds = arrayListings.map((listing, _) => listing.id);
    const {
      selectAllListings,
      unselectAllListings
    } = this._withInjectedProps.teamDetail;

    return (
      <Fragment>
        <Checkbox
          onChange={event => {
            if (event.target.checked) {
              selectAllListings(listingIds);
            } else {
              unselectAllListings();
            }
          }}
        >
          Select all
        </Checkbox>
        <List
          itemLayout="horizontal"
          dataSource={arrayListings}
          renderItem={(listing: any) => (
            <List.Item>{this._renderItemListing(listing)}</List.Item>
          )}
        />
      </Fragment>
    );
  }

  private _renderItemListing(listing: any) {
    return (
      <Row>
        <Col span={9}>
          <Avatar
            shape="square"
            size={64}
            src={listing.images.length > 0 ? listing.images[0].url : ''}
          />
        </Col>
        <Col span={14}>
          <Row>
            <b>{listing.name}</b>
          </Row>
          <Row>{listing.address}</Row>
        </Col>
        <Col span={1}>
          <Checkbox
            onChange={event => this.onChangeSelectListing(event, listing.id)}
          />
        </Col>
      </Row>
    );
  }

  private _getListings() {
    const {entriesList} = this._withInjectedProps.listingsList;
    return entriesList;
  }

  private _loadListing() {
    const params = {
      _limit: 100,
      _offset: 0,
      team_id: this._teamId
    };
    this._withInjectedProps.listingsList.loadEntries(params);
  }

  private _renderBasicInfo(team: any) {
    const {entriesList} = this._withInjectedProps.listingsList;

    return (
      <Row className="basic-info">
        <Col span={5}>
          <Avatar src={team.avatar} size={100} />
          <p className="team-name">{team.name}</p>
          <Row>
            <Col span={4} className="item-stats">
              <Icon type="team" title="Num of members" />
              {team.members.size}
            </Col>
            <Col span={4} className="item-stats">
              <Icon type="bank" title="Num of listings" />
              {entriesList.length}
            </Col>
          </Row>
          <Row>
            <p>{team.about}</p>
          </Row>
        </Col>

        <Col span={17}>
          <Row className="item-basic">
            <Col span={8} className="item-header">
              Email
            </Col>
            <Col span={16} className="item-content">
              {team.email}
            </Col>
          </Row>
          <Row className="item-basic">
            <Col span={8} className="item-header">
              Domain Name
            </Col>
            <Col span={16} className="item-content">
              {`https://${team.domainName}.cohost.club`}
            </Col>
          </Row>
          <Row className="item-basic">
            <Col span={8} className="item-header">
              Service Type
            </Col>
            <Col span={16} className="item-content">
              <Tag color="magenta">{team.serviceType}</Tag>
            </Col>
          </Row>
          <Row className="item-basic">
            <Col span={8} className="item-header">
              Owner
            </Col>
            <Col span={16} className="item-content">
              <Row>
                <Col span={4} className="item-header">
                  Name
                </Col>
                <Col span={20} className="item-content">
                  {`${team.owner.firstName} ${team.owner.lastName}`}
                </Col>
              </Row>
              <Row>
                <Col span={4} className="item-header">
                  Email
                </Col>
                <Col span={20} className="item-content">
                  {team.owner.email}
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>

        <Col span={2}>
          <Link to={`/teams/${this._teamId}/edit`}>
            <Button type="primary">
              <Icon type="edit" />
            </Button>
          </Link>
        </Col>
      </Row>
    );
  }

  private _renderFacebookAccount() {
    const {isLoading} = this._withInjectedProps.teamSettingDetail;
    return (
      <React.Fragment>
        <h3
          style={{
            fontSize: 20,
            fontWeight: 'bold',
            marginTop: 20,
            marginBottom: 15
          }}
        >
          Connected Facebook Pages
        </h3>
        {isLoading ? this._loading() : null}
        <Table
          bordered={true}
          columns={this._dataHeaderTableFacebookAccounts()}
          dataSource={this._cvtDataFacePages()}
          loading={isLoading}
        />
      </React.Fragment>
    );
  }

  private _renderZaloAccount() {
    const {isLoading} = this._withInjectedProps.teamSettingDetail;
    return (
      <React.Fragment>
        <h3
          style={{
            fontSize: 20,
            fontWeight: 'bold',
            marginTop: 20,
            marginBottom: 15
          }}
        >
          Connected Zalo OA
        </h3>
        {isLoading ? this._loading() : null}
        <Table
          bordered={true}
          columns={this._dataHeaderTableZaloAccounts()}
          dataSource={this._cvtDataZaloPages()}
          loading={isLoading}
        />
      </React.Fragment>
    );
  }

  private _renderOtaAccounts() {
    const {isLoading} = this._withInjectedProps.otaAccountsList;
    const {entries} = this._withInjectedProps.otaAccountsList;
    const isFetchAirbnbLoading = this._withInjectedProps
      .fetchAirbnbListingsAirbnb.isLoading;

    return (
      <React.Fragment>
        <h3
          style={{
            fontSize: 20,
            fontWeight: 'bold',
            marginTop: 15,
            marginBottom: 15,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
          }}
        >
          <span>Manage Connected OTA Accounts</span>
          &nbsp;
          <Badge count={entries.size} />
        </h3>
        <Button
          size="small"
          type="primary"
          onClick={this._toggleModelAddOtaAccount}
          style={{marginBottom: 15}}
        >
          Add New
        </Button>
        {isFetchAirbnbLoading ? this._loading() : null}
        <Table
          bordered={true}
          columns={this._dataHeaderTableOtaAccounts()}
          dataSource={this._cvtDataOtaAccounts()}
          loading={isLoading}
        />
      </React.Fragment>
    );
  }

  private _toggleModelAddOtaAccount = () => {
    this._withInjectedProps.teamDetail.onToggleAddNewOtaAccount();
    this._withInjectedProps.otaAccountsList.dataNewOtaAccount.onChangeTeamId(
      this._teamId
    );
  };

  private _toggleEditingOtaAccount = () => {
    this._withInjectedProps.teamDetail.onToggleEditOtaAccount();
  };

  private _renderAddNewOtaAccount() {
    const {isAddOtaAccount} = this._withInjectedProps.teamDetail;
    const formItemLayout = {
      labelCol: {
        xs: {span: 24},
        sm: {span: 8}
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16}
      }
    };

    return (
      <Modal
        title="Add New OTA Account"
        visible={isAddOtaAccount}
        onOk={this.onSubmitNewOtaAccount}
        onCancel={this._toggleModelAddOtaAccount}
        okText="Submit"
      >
        <Form>
          <Form.Item {...formItemLayout} label="Email">
            <Input
              placeholder="Enter email"
              onChange={this.onChangeEmailOtaAccount}
            />
          </Form.Item>
          {/* <Form.Item {...formItemLayout} label="Password">
            <Input.Password
              placeholder="Enter password"
              onChange={this.onChangePassOtaAccount}
            />
          </Form.Item> */}
          <Form.Item {...formItemLayout} label="User Name">
            <Input
              placeholder="User Name"
              onChange={this.onChangeUserNameOtaAccount}
            />
          </Form.Item>
          <Form.Item {...formItemLayout} label="Source">
            <Select
              style={{width: 150}}
              placeholder="Select source"
              onChange={this.onChangeSourceOtaAccount}
            >
              {Source.map((source: string, idx: number) => {
                return (
                  <Option key={source} value={source}>
                    {source}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item {...formItemLayout} label="Ota Host Id">
            <Input
              placeholder="Ota Host Id"
              onChange={this.onChangeOtaHostId}
            />
          </Form.Item>
        </Form>
      </Modal>
    );
  }

  private _renderModalEditOtaAccount() {
    const {
      email,
      source,
      userName,
      token,
      otaHostId
    } = this._withInjectedProps.otaAccountsList.dataUpdate;
    const {isEditOtaAccount} = this._withInjectedProps.teamDetail;
    const formItemLayout = {
      labelCol: {
        xs: {span: 24},
        sm: {span: 8}
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16}
      }
    };

    return (
      <Modal
        title="Edit Ota Account"
        visible={isEditOtaAccount}
        onOk={this.onSubmitUpdateOtaAccount}
        onCancel={this._toggleEditingOtaAccount}
        okText="Update"
      >
        <Form>
          <Form.Item {...formItemLayout} label="Email">
            <Input
              value={email}
              placeholder="Enter email"
              onChange={this.onChangeEmailOtaAccountForUpdate}
            />
          </Form.Item>
          {/* <Form.Item {...formItemLayout} label="Password">
            <Input.Password
              value={password}
              placeholder="Enter password"
              onChange={this.onChangePassOtaAccount}
            />
          </Form.Item> */}
          <Form.Item {...formItemLayout} label="User Name">
            <Input
              value={userName}
              placeholder="User Name"
              onChange={this.onChangeUserNameOtaAccountForUpdate}
            />
          </Form.Item>
          <Form.Item {...formItemLayout} label="Source">
            <Select<string>
              value={source}
              style={{width: 150}}
              placeholder="Select source"
              showSearch={true}
              onChange={this.onChangeSourceOtaAccountForUpdate}
            >
              {Source.map((source: string, idx: number) => {
                return (
                  <Option key={source} value={source}>
                    {source}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item {...formItemLayout} label="Ota Host Id">
            <Input
              value={otaHostId}
              placeholder="Ota Host Id"
              onChange={this.onChangeOtaHostIdForUpdate}
            />
          </Form.Item>
          <Form.Item {...formItemLayout} label="Token">
            <Input
              value={token}
              placeholder="Token"
              onChange={this.onChangeTokenForUpdate}
            />
          </Form.Item>
        </Form>
      </Modal>
    );
  }

  private onChangeEmailOtaAccountForUpdate = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    this._withInjectedProps.otaAccountsList.dataUpdate.onChangeEmail(
      event.target.value
    );
  };

  private onChangeUserNameOtaAccountForUpdate = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    this._withInjectedProps.otaAccountsList.dataUpdate.onChangeUserName(
      event.target.value
    );
  };

  private onChangeSourceOtaAccountForUpdate = (value: string) => {
    this._withInjectedProps.otaAccountsList.dataUpdate.onChangeSource(value);
  };

  private onChangeOtaHostIdForUpdate = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    this._withInjectedProps.otaAccountsList.dataUpdate.onChangeOtaHostId(
      event.target.value
    );
  };

  private onChangeTokenForUpdate = (event: React.ChangeEvent<HTMLInputElement>) => {
    this._withInjectedProps.otaAccountsList.dataUpdate.onChangeToken(event.target.value);
  };

  private onChangeEmailOtaAccount = (event: any) => {
    this._withInjectedProps.otaAccountsList.dataNewOtaAccount.onChangeEmail(
      event.target.value
    );
  };

  // private onChangePassOtaAccount = (event: any) => {
  //   this._withInjectedProps.otaAccountsList.dataNewOtaAccount.onChangePassword(
  //     event.target.value
  //   );
  // };

  private onChangeUserNameOtaAccount = (event: any) => {
    this._withInjectedProps.otaAccountsList.dataNewOtaAccount.onChangeUserName(
      event.target.value
    );
  };

  private onChangeSourceOtaAccount = (value: any) => {
    this._withInjectedProps.otaAccountsList.dataNewOtaAccount.onChangeSource(
      value
    );
  };

  private onChangeOtaHostId = (event: any) => {
    this._withInjectedProps.otaAccountsList.dataNewOtaAccount.onChangeOtaHostId(
      event.target.value
    );
  };

  private onChangeStaahHotelId = (event: any) => {
    this._withInjectedProps.teamSettingDetail.onChangeHotelId(
      event.target.value
    );
  };

  private onChangeStaahUsername = (event: any) => {
    this._withInjectedProps.teamSettingDetail.onChangeUsername(
      event.target.value
    );
  };

  private onChangeStaahPassword = (event: any) => {
    this._withInjectedProps.teamSettingDetail.onChangePassword(
      event.target.value
    );
  };

  private onSubmitNewOtaAccount = () => {
    this._withInjectedProps.otaAccountsList.createNew(this.notifyMessage);
    this._withInjectedProps.teamDetail.onToggleAddNewOtaAccount();
  };

  private onSubmitUpdateOtaAccount = () => {
    const {id} = this._withInjectedProps.otaAccountsList.dataUpdate;
    if (id) {
      try {
        this._withInjectedProps.otaAccountsList.updateOtaAccount(
          id,
          this.notifyMessage
        );
      } finally {
        this._withInjectedProps.teamDetail.onToggleEditOtaAccount();
      }
    }
  };

  private _renderSelectRole() {
    const {entries} = this._withInjectedProps.rolesList;
    if (entries) {
      const roles = Array.from(entries.values());
      return roles.map((role, idx: number) => {
        return (
          <Option key={role.code} value={role.id}>
            {role.name}
          </Option>
        );
      });
    }
    return null;
  }
  private _dataHeaderTableMembers() {
    return [
      {
        title: 'Id',
        dataIndex: 'id',
        key: 'id'
      },
      {
        title: 'Avatar',
        dataIndex: 'avatar',
        key: 'avatar'
      },
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        ...this.getColumnSearchProps('name')
      },
      {
        title: 'Role',
        dataIndex: 'role',
        key: 'role',
        ...this.getColumnSearchProps('role')
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        ...this.getColumnSearchProps('email')
      },
      {
        title: 'Actions',
        dataIndex: 'actions',
        key: 'actions'
      }
    ];
  }

  private _dataHeaderTableListings() {
    return [
      {
        title: 'Id',
        dataIndex: 'id',
        key: 'id'
      },
      {
        title: 'Image',
        dataIndex: 'image',
        key: 'image'
      },
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name'
        // ...this.getColumnSearchProps('name')
      },
      {
        title: 'Ota Listing Id',
        dataIndex: 'otaListingId',
        key: 'otaListingId'
      },
      {
        title: 'Source',
        dataIndex: 'source',
        key: 'source'
        // ...this.getColumnSearchProps('source')
      },
      {
        title: 'Members',
        dataIndex: 'members',
        key: 'members'
      },
      {
        title: 'Actions',
        dataIndex: 'actions',
        key: 'actions'
      }
    ];
  }

  private _dataHeaderTableOtaAccounts() {
    return [
      {
        title: 'Id',
        dataIndex: 'id',
        key: 'id'
      },
      {
        title: 'Avatar',
        dataIndex: 'avatar',
        key: 'avatar'
      },
      {
        title: 'User Name',
        dataIndex: 'userName',
        key: 'userName'
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email'
      },
      {
        title: 'Source',
        dataIndex: 'source',
        key: 'source'
      },
      {
        title: 'Token',
        dataIndex: 'token',
        key: 'token'
      },
      {
        title: 'State',
        dataIndex: 'state',
        key: 'state'
      },
      {
        title: 'Ota Host Id',
        dataIndex: 'otaHostId',
        key: 'otaHostId'
      },
      {
        title: 'Airlock Id',
        dataIndex: 'airlockId',
        key: 'airlockId'
      },
      {
        title: 'Actions',
        dataIndex: 'actions',
        key: 'actions'
      }
    ];
  }

  private _dataHeaderTableFacebookAccounts() {
    return [
      {
        title: 'Page Id',
        dataIndex: 'id',
        key: 'id'
      },
      {
        title: 'Avatar',
        dataIndex: 'avatar',
        key: 'avatar'
      },
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name'
      }
    ];
  }

  private _dataHeaderTableZaloAccounts() {
    return [
      {
        title: 'Page Id',
        dataIndex: 'id',
        key: 'id'
      },
      {
        title: 'Avatar',
        dataIndex: 'avatar',
        key: 'avatar'
      },
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name'
      }
    ];
  }

  private _cvtDataMembers(members: any) {
    const listMembers = Array.from(members.values());
    return listMembers.map((member: any, idex: number) => {
      return this._itemMemberTable(member);
    });
  }

  private _cvtDataOtaAccounts() {
    const {entries} = this._withInjectedProps.otaAccountsList;
    const otaAccounts = Array.from(entries.values());
    return otaAccounts.map((account: any, idex: number) => {
      return this._itemOtaAccount(account);
    });
  }

  private _cvtDataFacePages() {
    const {teamSetting} = this._withInjectedProps.teamSettingDetail;
    if (
      teamSetting &&
      teamSetting.teamSetting &&
      teamSetting.teamSetting.facebookSetting
    ) {
      const facebookPages =
        teamSetting.teamSetting.facebookSetting.params.pages || [];
      return facebookPages.map(page => {
        return {
          key: page.id,
          id: page.id,
          name: (
            <a href={`https://facebook.com/${page.id}`} target="_blank">
              {page.name}
            </a>
          ),
          avatar: <Avatar src={page.avatar} shape="square" />
        };
      });
    }
    return [];
  }

  private _cvtDataZaloPages() {
    const {teamSetting} = this._withInjectedProps.teamSettingDetail;
    if (
      teamSetting &&
      teamSetting.teamSetting &&
      teamSetting.teamSetting.zaloSetting
    ) {
      const zaloPages = teamSetting.teamSetting.zaloSetting.params.oas || [];
      return zaloPages.map(page => {
        return {
          key: page.id,
          id: page.id,
          name: <a href={`https://oa.zalo.me/${page.id}`}>{page.name}</a>,
          avatar: <Avatar src={page.avatar} shape="square" />
        };
      });
    }
    return [];
  }

  private _cvtDataListings(entries: any) {
    const listings = Array.from(entries.values());
    return listings.map((listing: any, idex: number) => {
      return this._itemListingTable(listing);
    });
  }

  private _itemMemberTable(member: any) {
    const {id, firstName, lastName, avatar, role, email} = member;
    return {
      key: id,
      id: <Link to={`/users/${id}`}>{id}</Link>,
      avatar: <Avatar shape="square" src={avatar} />,
      name: `${firstName} ${lastName}`,
      email: email,
      role: role ? role.name : 'Not found',
      actions: (
        <Popconfirm
          title="Are you sure delete this member?"
          onConfirm={() => this.onClickDeleteMember(id)}
          okText="Yes"
          cancelText="No"
        >
          <Button type="danger" size="small" icon="delete" />
        </Popconfirm>
      )
    };
  }

  private _itemOtaAccount(account: any) {
    return {
      key: account.id,
      id: account.id,
      avatar: <Avatar shape="square" src={account.avatar} />,
      email: account.email,
      userName: account.userName,
      source: (
        <Avatar
          shape="square"
          src={this._getIcon(account.source)}
          size="small"
        />
      ),
      token: account.token,
      state: account.state,
      otaHostId: account.otaHostId,
      airlockId: account.airlockId,
      actions: (
        <React.Fragment>
          <Button
            type="dashed"
            size="small"
            icon="edit"
            onClick={() => this.onChangeOtaAccountUpdate(account)}
          />

          {account.source === 'airbnb.com' ? (
            <Popconfirm
              title="Do you want refresh Airbnb listings cache?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => {
                this._withInjectedProps.fetchAirbnbListingsAirbnb.fetchAirbnbListings(
                  account.id,
                  [],
                  true,
                  this.notifyMessage
                );
              }}
            >
              <Button type="primary" size="small" icon="sync" />
            </Popconfirm>
          ) : null}

          <Popconfirm
            title="Are you sure delete this member?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => this.onRemoveOtaAccount(account.id)}
          >
            <Button type="danger" size="small" icon="delete" />
          </Popconfirm>
        </React.Fragment>
      )
    };
  }

  private onChangeOtaAccountUpdate(account: any) {
    this._withInjectedProps.otaAccountsList.onChangeDataUpdate(account.id);
    this._withInjectedProps.teamDetail.onToggleEditOtaAccount();
  }

  private onRemoveOtaAccount(otaAccountId: number) {
    this._withInjectedProps.otaAccountsList.removeOtaAccount(otaAccountId);
  }

  private _getListingId(otaListingId: string) {
    return otaListingId.slice(3);
  }

  private _itemLanguageTable(language: any) {
    const {id, name, code} = language;
    return {
      key: id,
      id,
      name,
      code
    };
  }
  private _itemListingTable(listing: any) {
    const {
      id,
      name,
      internalName,
      otaListingId,
      source,
      address,
      images,
      members
    } = listing;
    return {
      key: id,
      id: id,
      image: (
        <Avatar
          shape="square"
          size="large"
          src={images.length > 0 ? images[0].url : ''}
        />
      ),
      otaListingId: otaListingId,
      name: (
        <a
          href={
            source == 'airbnb.com'
              ? `https://www.airbnb.com/rooms/${this._getListingId(
                  otaListingId
                )}`
              : ''
          }
          target="_blank"
        >
          <Row>
            <b>{name}</b>
            <p style={{color: '#ffe58f'}}>{internalName}</p>
            <p>{address}</p>
          </Row>
        </a>
      ),
      source: (
        <Avatar shape="square" src={this._getIcon(source)} size="small" />
      ),
      address: address,
      members: members ? members.size : 0,
      actions: <Link to={`/listings/${id}`}>Details</Link>
    };
  }

  private onClickDeleteMember(memberId: number) {
    this._withInjectedProps.teamDetail.removeUserToTeam(
      this._teamId,
      memberId
    );
  }

  private onChangeSelectListing(event: any, listingId: number) {
    const {checked} = event.target;
    // this._withInjectedProps.listingsList.toogleJoined(listingId);
    if (checked) {
      this._withInjectedProps.teamDetail.addListingSelected(listingId);
    } else {
      this._withInjectedProps.teamDetail.removeListingSelected(listingId);
    }
  }

  // private onEditTeamName = () => {
  //   this.onToggleEditTeamName();
  // };

  private onToggleEditTeamName = () => {
    this._withInjectedProps.teamDetail.onToggleEditTeamName();
  };

  private onSubmitTeamName = () => {
    this._withInjectedProps.teamDetail.updateTeam(
      this._teamId,
      this.notifyMessage,
      undefined
    );
    this._withInjectedProps.teamDetail.onToggleEditTeamName();
  };

  private onChangeTeamName = (event: any) => {
    this._withInjectedProps.teamDetail.onChangeTeamName(event.target.value);
  };

  private _renderEditTeamName(team: any) {
    const {isEditingTeamName} = this._withInjectedProps.teamDetail;
    return (
      <Modal
        title="Edit team name"
        visible={isEditingTeamName}
        onOk={this.onSubmitTeamName}
        onCancel={this.onToggleEditTeamName}
      >
        <Input
          placeholder="Enter team name"
          defaultValue={team.name}
          onChange={this.onChangeTeamName}
        />
      </Modal>
    );
  }

  private _getIcon(source: string) {
    switch (source) {
      case 'airbnb.com':
        return airbnBadge;
      case 'booking.com':
        return bookingBadge;
      case 'hotelrunner.com':
        return cohostBadge;
    }
  }

  private notifyMessage(type: string, msg: string) {
    switch (type) {
      case 'error':
        message.error(msg);
        break;
      case 'success':
        message.success(msg);
        break;
      case 'warning':
        message.warning(msg);
    }
  }
}

export default TeamDetail;



// WEBPACK FOOTER //
// ./src/pages/TeamDetail/TeamDetail.tsx